<div class="footer-buttons dropdown is-up is-right" [class.is-active]="expanded">
  <div class="dropdown-trigger">
    <button (click)="expanded=!expanded"
            class="button is-primary" [class.is-outlined]="!selectedElement"
            aria-haspopup="true" aria-controls="dropdown-menu">
      <span *ngIf="!selectedElement">{{ label }}</span>
      <span *ngIf="selectedElement" class="is-capitalized">{{selectedElement.name}}</span>
      <span class="icon is-small">
                  <i class="fas"
                     [class.fa-angle-up]="expanded"
                     [class.fa-angle-left]="!expanded" aria-hidden="true"></i>
                </span>
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content expressionCancerType-dropdown">
      <div class="scroll-area">
        <a (click)="onSelect(null)"
           [class.is-active]="!selectedElement"
           class="dropdown-item">
          None
        </a>
        <a *ngFor="let elem of elements"
           (click)="onSelect(elem)"
           [class.is-active]="selectedElement && elem.backendId === selectedElement.backendId"
           class="dropdown-item is-capitalized">
          {{elem.name}}
        </a>
      </div>
    </div>
  </div>
</div>
